module.exports = __webpack_public_path__ + "img/menu-10.6c8e5d58.jpg";